<template>
  <div v-if="show">
    <el-form-item
      :label="`${label}（第${i}${unit}）`"
      v-for="i in num"
      :key="i"
      :prop="`${prop}.${i - 1}`"
      :rules="rules"
    >
      <el-input
        :readonly="readonly"
        size="mini"
        placeholder="请输入"
        :value="value[i - 1]"
        @input="input(i - 1, $event)"
      >
      </el-input>
    </el-form-item>
  </div>
  <el-form-item v-else :label="label">
    --
  </el-form-item>
</template>

<script>
// 按年份输入
import debounce from 'lodash/debounce';

export default {
  props: {
    value: Array,
    count: [Number, String],
    label: String,
    rules: Array,
    prop: String,
    readonly: Boolean,
    unit: {
      type: String,
      default: '年'
    },
    defaultValue: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    num() {
      return +this.count;
    },
    show() {
      return !window.isNaN(this.num) && this.num > 0;
    }
  },
  watch: {
    count() {
      this.computeValue();
    }
  },
  methods: {
    compute() {
      const val = this.count;
      let v = [...this.value];
      if (val < v.length && val !== 0) {
        v = v.slice(0, val);
      } else if (val > v.length) {
        let count = val - v.length;
        while (count > 0) {
          v.push(this.defaultValue);
          count -= 1;
        }
      }
      this.$emit('input', v);
    },
    input(i, value) {
      const v = [...this.value];
      v[i] = value;
      this.$emit('input', v);
    }
  },
  mounted() {
    this.computeValue = debounce(this.compute, 600);
    this.computeValue();
  }
};
</script>
